<app-header
  [showBackButton]="true"
  [defaultBackUrl]="defaultBackUrl"
  [headerData]="headerDataValues"
  class="full"
></app-header>
<app-offline-mode></app-offline-mode>
<ion-content>
  <div class="spinner" *ngIf="loading">
    <ion-spinner name="lines"></ion-spinner>
  </div>
  <ion-item
    [button]="isRequestInWork"
    class="item ion-no-padding"
    *ngFor="let item of carsList; index as i"
    mode="md"
    (click)="openCarDetails(item, i + 1)"
  >
    <div class="item-container">
      <div class="index">
        {{ i + 1 }}
      </div>
      <div class="car-details">
        <div class="car-number">{{ item.registrationNumber }}</div>
        <div class="info">
          <div>
            Водитель: <strong>{{ item.driverName }}</strong>
          </div>
          <div>
            Владелец: <strong>{{ item.carrierName }}</strong>
          </div>
          <div>
            Телефон:
            <strong *ngIf="item.driverPhone" class="driver-phone">{{
              item.driverPhone
            }}</strong>
          </div>
        </div>
        <div
          *ngIf="isRequestInWork && item?.loadingData?.netWeight"
          class="shipped"
        >
          <strong>Отгружено:</strong>
          <div class="tons">{{ item.loadingData.netWeight }} кг</div>
        </div>

        <div
          *ngIf="isRequestInWork && hasIncompleteLoadingData(item)"
          class="warning"
        >
          <ion-icon name="warning-outline" color="warning"></ion-icon>
          <div class="warning-text">завершите заполнение данных</div>
        </div>

        <div
          *ngIf="isRequestInWork && !dayDetails?.completed"
          class="ready-to-load"
        >
          <div class="title">Присутствие ТС :</div>
          <div class="slider">
            <span
              [ngClass]="{
                'disabled-text': item.isCarAtLoadingSite,
              }"
              >Нет</span
            >
            <div
              class="toggle-wrapper"
              (click)="$event.stopPropagation()"
              (keyup)="$event.stopPropagation()"
              (keydown)="$event.stopPropagation()"
              tabindex="0"
              role="switch"
              [attr.aria-checked]="item.isCarAtLoadingSite"
            >
            <ion-toggle
              class="custom-toggle"
              (ionChange)="onToggleChange($event, i)"
              [ngClass]="{
                checked: item.isCarAtLoadingSite,
                unchecked: !item.isCarAtLoadingSite
              }"
              [checked]="item.isCarAtLoadingSite"
              [disabled]="!isDayStarted"
            >
            </ion-toggle>
             </div>
            <span
              [ngClass]="{
                'disabled-text': !item.isCarAtLoadingSite,
              }"
              >Да</span
            >
          </div>
        </div>
      </div>
    </div>
  </ion-item>
  <div
    *ngIf="dayDetails && dayDetails.completed && dayDetails.forwarderNoteDocumentId"
    class="additional-button-wrapper"
  >
    <app-download-file-button
      [documentId]="dayDetails.forwarderNoteDocumentId"
      [fileName]="'Расписка экспедитора-' + order.contractName + '.pdf'"
      buttonText="Расписка экспедитора"
    ></app-download-file-button>
  </div>
</ion-content>
<ion-footer *ngIf="isRequestInWork && !dayDetails?.completed">
  <app-swipe-button
    *ngIf="!isDayStarted"
    [title]="'Начать день'"
    [isSwiped]="isDayStarted"
    (swipedEvent)="dayStart($event)"
    [disabled]="disableDayStartSwipe"
  >
  </app-swipe-button>

  <ion-button *ngIf="isDayStarted" [disabled]="disableDayEndButton" (click)="dayEnd()" class="primary large" mode="md">
    Завершить день
  </ion-button>
</ion-footer>
